import { deserializeYesplanAPIDate } from '../libs/dateTimeUtilities';
import { printInShortFormatOrAsRelativeDate } from '../libs/dateTimePrinting';
import AbstractNotification from './YPAbstractNotificationObject';
import { hashString } from '../libs/stringHashing';

export default class AbstractWidgetNotification extends AbstractNotification {
  constructor(id, timestampString, isRead, notificationMessage) {
    super(id, timestampString, isRead, notificationMessage.notificationText);
    this.dateObjects = notificationMessage.notificationDates.map((dateString) =>
      deserializeYesplanAPIDate(dateString)
    );
  }

  getNotificationMessageDates() {
    return this.dateObjects;
  }

  shouldPrintDividerAfterNotification(notificationList) {
    const index = notificationList.findIndex(
      (notification) => notification.id === this.id
    );
    return index !== -1 && index < notificationList.length - 1;
  }

  printNotificationDate(dateString, dateFormatSetting) {
    return printInShortFormatOrAsRelativeDate(
      deserializeYesplanAPIDate(dateString),
      dateFormatSetting,
      true,
      false
    );
  }

  printDetailedDescriptionRosterNotification() {
    return this.notificationMessage;
  }

  getNotificationIdWithMessageHash() {
    const hashedMessage = hashString(this.notificationMessage);
    return `${this.id}-${hashedMessage}`;
  }
}
